export default "__VITE_ASSET__DRhSbcog__"